import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import authService from './services/authService.jsx';

const getRoleDashboardPath = (role) => {
  return role === 'Artisan' ? '/artisan/dashboard/in-progress' : '/customer/dashboard/posted';
};

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const location = useLocation();

  // Check if user is authenticated
  if (!authService.isAuthenticated()) {
    // Redirect to login page with the current location as state
    // so user can be redirected back after login
    return <Navigate to="/" state={{ from: location.pathname }} replace />;
  }

  const onboardingState = authService.getRequiredOnboardingState();
  if (onboardingState) {
    return <Navigate to="/signup" state={onboardingState} replace />;
  }

  // Check role-based access if required
  if (requiredRole) {
    const userRole = authService.getUserRole();
    if (userRole !== requiredRole) {
      return <Navigate to={getRoleDashboardPath(userRole)} replace />;
    }
  }

  // User is authenticated and has required role (if any)
  return children;
};

export default ProtectedRoute;
